module.exports = __webpack_public_path__ + "static/media/8.f82f7cc7.svg";